import { LicenceConstants } from './licence.constants';
import { LicenceInterface, LicenceResponseInterfaceAll, LicenceResponseInterfaceSingle, ReducerActionInterface } from '../../interfaces';

// ============ INTERFACE ============

export interface LicenceStateInterface {
  currentLicence?: LicenceInterface;
  licences?: LicenceResponseInterfaceAll;
  error?: string;
}

// ============ INIT STATE ============

const initialState: LicenceStateInterface = {
  currentLicence: undefined,
  licences: {
    data: [],
    meta: {
      totalResourceCount: 0
    }
  }
}

// ============ REDUCERS ============

const getSingleSuccess = (state: LicenceStateInterface, payload: LicenceResponseInterfaceSingle): LicenceStateInterface => {
  return {
    ...state,
    currentLicence: payload.data,
  };
};

const getAllSuccess = (state: LicenceStateInterface, payload: LicenceResponseInterfaceAll): LicenceStateInterface => {
  return {
    ...state,
    licences: {
      data: payload.data,
      meta: payload.meta
    }
  };
};

const createSuccess = (state: LicenceStateInterface, payload: LicenceResponseInterfaceSingle): LicenceStateInterface => {
  return {
    ...state,
    currentLicence: payload.data,
  };
};

const updateSuccess = (state: LicenceStateInterface, payload: LicenceResponseInterfaceSingle): LicenceStateInterface => {
  return {
    ...state,
    currentLicence: payload.data,
  };
};

const clearCurrent = (state: LicenceStateInterface): LicenceStateInterface => {
  return {
    ...state,
    currentLicence: undefined,
  };
};

const clearList = (state: LicenceStateInterface): LicenceStateInterface => {
  return {
    ...state,
    licences: {
      data: [],
      meta: {
        totalResourceCount: 0
      }
    }
  };
};

const deleteSuccess = (state: LicenceStateInterface): LicenceStateInterface => {
  return {
    ...state,
    currentLicence: undefined,
  };
};

const error = (state: LicenceStateInterface, payload: string) => {
  return {
    ...state,
    error: payload,
  };
};

// ============ EXPORTS ============

export const LicenceReducer = (state = initialState, action: ReducerActionInterface) => {
  switch (action.type) {
    case LicenceConstants.GET_SINGLE_SUCCESS:
      return getSingleSuccess(state, action.payload);
    case LicenceConstants.GET_ALL_SUCCESS:
      return getAllSuccess(state, action.payload);
    case LicenceConstants.CREATE_SUCCESS:
      return createSuccess(state, action.payload);
    case LicenceConstants.UPDATE_SUCCESS:
      return updateSuccess(state, action.payload);
    case LicenceConstants.CLEAR_CURRENT:
      return clearCurrent(state);
    case LicenceConstants.CLEAR_LIST:
      return clearList(state);
    case LicenceConstants.DELETE:
      return deleteSuccess(state);
    case LicenceConstants.ERROR:
      return error(state, action.payload);
    default:
      return state;
  }
};
